module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "停车场信息",
      "name": "common"
    }
  }, [_c('form-panel', {
    ref: "formPanel",
    on: {
      "saved": _vm.onFormSaved
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "通道信息",
      "name": "channel",
      "disabled": !this.id
    }
  }, [_c('channel-panel', {
    ref: "channelPanel"
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73793f84","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/app/parkInfo/Edit.vue
// module id = 347
// module chunks = 0